//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
  name: "repair-detail-paidan-view",
  components: {},
  props: {
    workOrderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      records: [],
      showReceiptPopup: false,
      showChargebackPopup: false,
      paiDanId: 0

    }
  },
  computed: {
    memberPermission() {
      return this.$store.state.workOrder.memberPermission;
    }
  },
  methods: {
    getPaiDans() {
      const vm = this;
      abp.ajax.get('/api/services/app/WorkOrder/GetPaiDansByWorkOrderId?workOrderId=' + this.workOrderId).then(res => {

        vm.records = [];
        vm.records.push(...res.data.result);
      }).finally(() => {

      })
    },
    showReceipt(item) {
      this.paiDanId = item.id
      this.showReceiptPopup = true;

    }
  },
  created() {
    if (this.workOrderId > 0) {
      this.getPaiDans();
    }
  },
  watch: {
    workOrderId() {
      if (this.workOrderId > 0) {
        this.getPaiDans();
      }
    }
  }
}
